import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  PanelToggle,
  PANEL_TOGGLE_TITLE_VARIANT_S
} from 'mailup-web-components'

import { messageState } from '../../../recoil/state/message'
import { useRecoilCallback, useRecoilState } from 'recoil'
import { getMessageContentCallback } from '../../../recoil/callbacks/callbacks'
import ReactTooltip from 'react-tooltip'

const EmbeddedImages = () => {
  const intl = useIntl()
  const getMsgContentCallback = useRecoilCallback(getMessageContentCallback, [])
  const [{ embed, embedItems, id }, setEmbed] = useRecoilState(messageState)

  function onClickSetEmbed(checkState) {
    setEmbed(prev => ({
      ...prev,
      embed: !checkState,
      isDirty: true
    }))
  }

  useEffect(() => {
    ReactTooltip.rebuild()
    if (id && !embedItems) {
      getMsgContentCallback(id)
    }
  }, [id, embedItems])

  return (
    <>
      <PanelToggle
        title={intl.formatMessage({
          id: 'Load.SavedEmailWizard.LabelEmbeddedImages'
        })}
        titleVariant={PANEL_TOGGLE_TITLE_VARIANT_S}
        titleTooltip={
          embedItems && embedItems.length === 0
            ? intl.formatMessage({
                id: 'Load.SavedEmailWizard.EmbeddedImagesTooltip'
              })
            : intl.formatMessage({
                id: 'Load.SavedEmailWizard.EmbeddedImagesNotAllowed'
              })
        }
        checked={embedItems && embedItems.length > 0 ? false : embed}
        disabled={embedItems && embedItems.length > 0}
        onChange={() => onClickSetEmbed(embed)}
        data-mu-test='overview-message__box-embedded-image'
      />
    </>
  )
}

export default EmbeddedImages
